export default "__VITE_ASSET__180f8d51__"